import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JobSaveComponent } from './components/job-save/job-save.component';
import { JobListComponent } from './components/job-list/job-list.component';
import { AgentApplicationListComponent } from './components/application-list/application-list.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { AgentListComponent } from '../web/components/agent-list/agent-list.component';
import { AgentDetailComponent } from '../web/components/agent-detail/agent-detail.component';

const routes: Routes = [
  { path: '', component: AgentListComponent, data: { title: 'کاریابی‌ها', hideBanner: true } },
  { path: 'ads/save', component: JobSaveComponent, canActivate: [AuthGuard], data: { role: 'Agent' } },
  { path: 'ads/save/:id', component: JobSaveComponent, canActivate: [AuthGuard], data: { role: 'Agent' } },
  { path: 'applies/:id', component: AgentApplicationListComponent, canActivate: [AuthGuard], data: { role: 'Agent' } },
  { path: 'ads', component: JobListComponent, canActivate: [AuthGuard], data: { role: 'Agent' } },
  { path: ':code', component: AgentDetailComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgentRoutingModule { }
